module.exports = flarum.core.compat['utils/classList'];